import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  concatWith,
  forkJoin,
  map,
  mergeMap,
  of,
  switchMap
} from 'rxjs';
import { AuthActions } from '@components/auth/auth.actions';
import { ReportPersonaHealthGuidelineActions } from './health-guideline.actions';
import { ReportPersonaHealthGuidelineService } from './health-guideline.service';

/**
 * Report Persona Health Guideline Effects.
 *
 * @exports
 * @class ReportPersonaHealthGuidelineEffects
 * @augments {ReportPersonaHealthGuidelineService}
 */
@Injectable()
export class ReportPersonaHealthGuidelineEffects extends ReportPersonaHealthGuidelineService {
  private readonly actions = inject(Actions);

  readonly onAuthLogout_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout, AuthActions.switchProfile),
        map(() => ReportPersonaHealthGuidelineActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetch = createEffect(
    () => {
      return this.actions.pipe(
        ofType(ReportPersonaHealthGuidelineActions.fetch),
        switchMap(() =>
          of(
            ReportPersonaHealthGuidelineActions.updateLoading({
              loading: true
            })
          ).pipe(
            concatWith(
              forkJoin({
                compatibility: this.relationshipCompatibility().pipe(
                  catchError((error) => {
                    // eslint-disable-next-line no-console
                    console.error(
                      `Error in relationshipCompatibility fetch`,
                      error
                    );
                    return of(null);
                  })
                ),
                career: this.careerPath().pipe(
                  catchError((error) => {
                    // eslint-disable-next-line no-console
                    console.error(`Error in careerPath fetch`, error);
                    return of({
                      count: 0,
                      results: []
                    });
                  })
                )
              }).pipe(
                mergeMap(({ compatibility, career }) => [
                  ReportPersonaHealthGuidelineActions.setCompatibility({
                    compatibility
                  }),
                  ReportPersonaHealthGuidelineActions.setCareer({
                    career
                  }),
                  ReportPersonaHealthGuidelineActions.updateLoading({
                    loading: false
                  })
                ])
              )
            )
          )
        )
      );
    },
    { dispatch: true }
  );
}
